var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1359-944H83V80h-1442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1358-14H84v94h-1442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30-3H70v70H-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 3.333H6.667c-1.834 0-3.317 1.5-3.317 3.334l-.017 30L10 30h23.333c1.834 0 3.334-1.5 3.334-3.333v-20c0-1.834-1.5-3.334-3.334-3.334zM10 15h20v3.333H10V15zm13.333 8.333H10V20h13.333v3.333zm6.667-10H10V10h20v3.333z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.50d714ee790d238e0a777684cb920480.svg";
export { ForwardRef as ReactComponent };